import request from '@/utils/request'

export default {
  fetchMetadata (params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/site/metadata`,
      method: 'get',
      params
    })
  }
}
